/* Presentation only: Empire remains responsible for carousel navigation and editor events. */
(() => {
  const selector = 'section-slideshow[data-only-games-slideshow]';
  const instances = new WeakMap();
  function mount(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const update = () => {
      root.querySelectorAll('[data-slide-image-wrapper]').forEach(wrapper => {
        const image = [...wrapper.querySelectorAll('img')].find(img => getComputedStyle(img).display !== 'none');
        if (!image || !image.naturalWidth || !wrapper.clientHeight) return;
        const ratio = image.naturalWidth / image.naturalHeight;
        const frame = wrapper.clientWidth / wrapper.clientHeight;
        const contain = root.dataset.imageFit === 'contain' || (root.dataset.imageFit === 'auto' && Math.abs(ratio / frame - 1) > .08);
        wrapper.classList.toggle('og-banner-contained', contain);
        let backdrop = wrapper.querySelector('.og-banner-backdrop');
        if (contain && root.dataset.imageFill === 'blur') {
          if (!backdrop) {
            backdrop = document.createElement('div');
            backdrop.className = 'og-banner-backdrop';
            backdrop.setAttribute('aria-hidden', 'true');
            wrapper.prepend(backdrop);
          }
          const url = image.currentSrc || image.src;
          if (backdrop.dataset.source !== url) {
            backdrop.style.backgroundImage = `url(${JSON.stringify(url)})`;
            backdrop.dataset.source = url;
          }
        }
        if (backdrop) backdrop.hidden = !contain || root.dataset.imageFill !== 'blur';
      });
    };
    const resize = new ResizeObserver(update);
    resize.observe(root);
    root.querySelectorAll('[data-slide-image-wrapper]').forEach(el => resize.observe(el));
    const mutations = new MutationObserver(update);
    mutations.observe(root, { childList: true, subtree: true });
    root.addEventListener('load', update, { capture: true, signal });
    root.addEventListener('focusin', () => root._pauseCustomAutoplay?.(), { signal });
    root.addEventListener('focusout', () => requestAnimationFrame(() => {
      if (!root.contains(document.activeElement) && root.autoplayActive) root._resumeCustomAutoplay?.();
    }), { signal });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) root._pauseCustomAutoplay?.();
      else if (root.autoplayActive) root._resumeCustomAutoplay?.();
    }, { signal });
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    motion.addEventListener('change', () => {
      if (motion.matches) root._stopCustomAutoplay?.();
    }, { signal });
    instances.set(root, () => { resize.disconnect(); mutations.disconnect(); controller.abort(); instances.delete(root); });
    update();
  }
  const scan = scope => {
    if (scope.matches?.(selector)) mount(scope);
    scope.querySelectorAll?.(selector).forEach(mount);
  };
  // This asset can be included by several slideshow instances.
  if (window.onlyGamesSlideshowMounted) return;
  window.onlyGamesSlideshowMounted = true;
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(root => instances.get(root)?.());
  });
})();
